<mat-form-field class="input-example">
  <mat-label class="label">Seleccionar Empresa </mat-label>
  <mat-select (selectionChange)="search($event.value)">
    <mat-option *ngFor="let item of empresas" [value]="item">{{
      item?.fS07NombreComercial
    }}</mat-option>
  </mat-select>
</mat-form-field>
